import { AxiosError } from "axios"
import clientApi from "@/shared/api/client"
import { ApiResponse } from "@/shared/types/interface/api"
import { buildRankingRequestBody } from "@/entities/search-ranking/lib/buildRankingRequestBody"
import { RankingApiResult, RankingGroupApiItem } from "@/entities/search-ranking/model/types"
import { SEARCH_RANKING_URL } from "@/entities/search-ranking/api/url"

export type RankingHospitalsRequest = {
  hospitalRankingGroupId: number
}

export const getRankingHospitalsClient = async (params: RankingHospitalsRequest) => {
  try {
    const body = buildRankingRequestBody(params.hospitalRankingGroupId)
    const response = await clientApi.post(SEARCH_RANKING_URL.RANKINGS, body)

    if (response.status !== 200) {
      throw new Error("Failed to get ranking hospitals")
    }

    return response.data as ApiResponse<RankingApiResult>
  } catch (error) {
    if (error instanceof AxiosError && !error.response) {
      throw new Error("No Response")
    }
    throw error
  }
}

export const getRankingGroupsClient = async () => {
  try {
    const response = await clientApi.get(SEARCH_RANKING_URL.RANKING_GROUPS)

    if (response.status !== 200) {
      throw new Error("Failed to get ranking groups")
    }

    return response.data as ApiResponse<RankingGroupApiItem[]>
  } catch (error) {
    if (error instanceof AxiosError && !error.response) {
      throw new Error("No Response")
    }
    throw error
  }
}
